import * as ConvertActions from '@app/shared/store/actions/converter.actions';

export interface State {
  isProjectLoaded: boolean,
}

export const initialState: State = {
  isProjectLoaded: false
};

export function reducer(
  state: State = initialState,
  action: ConvertActions.ConvertActions
): State {
  switch (action.type) {
    case ConvertActions.ConvertActionTypes.CONVERT_KRONAS_TO_JSON:
      return {
        ...state,
        isProjectLoaded: true,
      };
    case ConvertActions.ConvertActionTypes.CONVERT_KRONAS_TO_JSON_SUCCESS:
      return {
        ...state,
        isProjectLoaded: false,
      };
    default: {
      return state;
    }
  }
}

export const getIsProjectLoaded = (state: State) => state.isProjectLoaded;
